import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api-service/api.service';

/**
 * This service manages the api requests for enabling and disabling Business App tabs
 */
@Injectable({ providedIn: 'root' })
export class TabApiService {
  constructor(private apiService: ApiService) {}

  public enableAll(accountGroupId: string, userId: string): Observable<void> {
    const url = '/_ajax/v1/manage-users/vbc-tabs/enable-all/';
    const data = {
      accountGroupId: accountGroupId,
      userId: userId,
    };
    return this.apiService.post(url, data);
  }

  public disableAll(accountGroupId: string, userId: string): Observable<void> {
    const url = '/_ajax/v1/manage-users/vbc-tabs/disable-all/';
    const data = {
      accountGroupId: accountGroupId,
      userId: userId,
    };
    return this.apiService.post(url, data);
  }

  public set(accountGroupId: string, userId: string, tabIds: string[]): Observable<void> {
    const url = '/_ajax/v1/manage-users/vbc-tabs/set/';
    const data = {
      accountGroupId: accountGroupId,
      userId: userId,
      tabIds: tabIds,
    };
    return this.apiService.post(url, data);
  }

  public setMulti(
    userIds: string[],
    partnerTabIds: string[],
    tabIdsToAdd: string[],
    tabIdsToRemove: string[],
  ): Observable<void> {
    const url = '/_ajax/v1/manage-users/vbc-tabs/set/multi';
    const data = {
      userIds,
      partnerTabIds,
      tabIdsToAdd,
      tabIdsToRemove,
    };
    return this.apiService.post(url, data);
  }
}
